import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import RouteNetworkColorUtils from '@pages/route-network-page/utils/route-network-color.utils';
import { RegistryComponentNames } from '@shared/constants/registry-component-name';

@Component({
  selector: RegistryComponentNames.POiPopupContent,
  imports: [TranslateModule],
  templateUrl: './poi-popup-content.component.html',
  styleUrl: './poi-popup-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PoiPopupContentComponent {
  private sanitizer = inject(DomSanitizer);

  iconKey = input<string>();
  iconColor = input<string>();
  description = input<string>();
  purpose = input<string>();
  poiTypeKey = input<string>();
  severityKey = input<string>();

  get iconSvg(): SafeHtml | undefined {
    return this.iconKey()
      ? this.sanitizer.bypassSecurityTrustHtml(
          RouteNetworkColorUtils.getIconWithFill(
            this.iconKey()!,
            this.iconColor() || 'red'
          )
        )
      : undefined;
  }
}
